export const dataLibO = [{
  word: 'on',
  partOfSpeech: null,
  definition: [],
  egSentenceKw: 'I ni on gwo motoka.',
  egSentenceEn: 'He has a large car.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: 'an',
}, {
  word: 'ou',
  partOfSpeech: 'PRO',
  definition: ['second person singular pronoun'],
  egSentenceKw: 'Ou pèd lajan\'w?',
  egSentenceEn: 'Did you lose your money?',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: '\'w',
}, {
  word: 'ofon',
  partOfSpeech: 'PREP',
  definition: ['at the bottom of'],
  egSentenceKw: 'I twouvé papyé-a ofon an panyen.',
  egSentenceEn: 'He found the paper at the bottom of a basket.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. au fond]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'olyè',
  partOfSpeech: 'PREP',
  definition: ['instead of', 'rather than'],
  egSentenceKw: 'Sèvi sa mwen-an olyè sa ou-a.',
  egSentenceEn: 'Use mine instead of yours.',
  synonym: ['andji', 'pito'],
  antonym: [null],
  etymology: '[< Fr. au lieu]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'owon',
  partOfSpeech: 'PREP',
  definition: ['around'],
  egSentenceKw: 'Mwen maché tout owon vil ka gadé pou soulyé lékòl.',
  egSentenceEn: 'I walked all around town looking for school shoes.',
  synonym: ['alafen di', 'apipwé', 'avèwdi', 'bò', 'vèò'],
  antonym: [null],
  etymology: '[< Fr. au rond]',
  dialect: '🇱🇨',
  variant: ['oliwon'],
}, {
  word: 'owon',
  partOfSpeech: 'ADV',
  definition: ['approximately', 'about'],
  egSentenceKw: 'Mwen ni lidé chyen-an ni owon douz piti.',
  egSentenceEn: 'I think the dog has about twelve pups.',
  synonym: ['alafen di', 'apipwé', 'avèwdi', 'bò', 'vèò'],
  antonym: [null],
  etymology: '[< Fr. au rond]',
  dialect: '🇱🇨',
  variant: ['oliwon'],
},
];
